import {InvalidApplication, ValidApplication} from 'ApplicationEntry/models/Application';
import React from 'react';
import './../ApplicationEntry.sass';
import './../WorkFlow.sass';
import VerifyCriticalInformationForm from './VerifyCriticalInformationForm';
import Dialog from 'Shared/components/Dialog/Dialog';

type VerifyCriticalInformationDialogProps = {
  open: boolean;
  onClose: () => void;
  onSaveToLife70: () => void;
  application: ValidApplication | InvalidApplication;
};

const VerifyCriticalInformationDialog = (props: VerifyCriticalInformationDialogProps) => {
  const {application, onClose, open, onSaveToLife70} = props;
  return (
    <Dialog fullScreen open={open} onClose={onClose} title="Verify Critical Information">
      <VerifyCriticalInformationForm application={application} onCancel={onClose} onSaveToLife70={onSaveToLife70} />
    </Dialog>
  );
};

export default VerifyCriticalInformationDialog;
